<template>
  <section>
    <div class="user-wrapper">
      <div class="user-profile">
        <el-avatar :size="45" src="/images/default-user.png"></el-avatar>
      </div>
      <div class="user-info">
        <label class="name" v-text="user.username"></label>
        <label class="email" v-text="user.email"></label>
      </div>
    </div>
    <el-menu :collapse="isCollapse" :router="true">
      <li
        v-for="(route, index) in routes"
        :key="index"
        class="el-menu-item"
        :class="route.submenus.length > 0 ? 'menu-parent' : ''"
      >
        <router-link :to="route.path">
          <i :class="route.meta.menu.icon"></i
          ><span v-text="route.meta.menu.name"></span>
        </router-link>
        <template v-if="!isCollapse">
          <ul class="sidebar-submenu" v-if="route.submenus.length > 0">
            <li v-for="(child, index) in route.submenus" :key="index">
              <template v-if="'proxy' in child.meta">
                <router-link :to="{ name: child.meta.proxy }">
                  <span v-text="child.meta.menu.name"></span>
                </router-link>
              </template>
              <template v-else>
                <router-link :to="{ name: child.name }">
                  <span v-text="child.meta.menu.name"></span>
                </router-link>
              </template>
            </li>
          </ul>
        </template>
      </li>
    </el-menu>
  </section>
</template>

<script>
export default {
  name: "SideNavbar",
  computed: {
    isCollapse() {
      return this.$store.getters["ui/collapse"];
    },
    user() {
      if (this.$store.getters["auth/user"]) {
        return this.$store.getters["auth/user"];
      }
      return {};
    },
    routes() {
      var routes = this.$router.options.routes[0].children.filter(o => {
        var result = false;
        if (o.hasOwnProperty("meta") && o.meta.hasOwnProperty("menu")) {
          if (
            o.meta.hasOwnProperty("userType") &&
            typeof o.meta.userType == "number"
          ) {
            if (this.user.user_type == o.meta.userType) result = true;
          } else if (
            o.meta.hasOwnProperty("userType") &&
            typeof o.meta.userType == "object"
          ) {
            if (
              o.meta.userType.find(o => {
                return o == this.user.user_type;
              })
            )
              result = true;
          } else {
            result = true;
          }
        }
        return result;
      });

      for (let route of routes) {
        route.submenus = [];
        if ("children" in route && route.children.length > 0) {
          let children = route.children;
          let submenus = [];
          // console.log(sorted);
          for (let child of children) {
            if (
              child.hasOwnProperty("meta") &&
              child.meta.hasOwnProperty("menu")
            ) {
              if (
                child.meta.hasOwnProperty("userType") &&
                typeof child.meta.userType == "number"
              ) {
                if (this.user.user_type == child.meta.userType)
                  submenus.push(child);
              } else if (
                child.meta.hasOwnProperty("userType") &&
                typeof child.meta.userType == "object"
              ) {
                if (
                  child.meta.userType.find(o => {
                    return o == this.user.user_type;
                  })
                )
                  submenus.push(child);
              } else {
                submenus.push(child);
              }
            }
          }
          let sorted = submenus.sort((a, b) => {
            if (a.meta.menu.name < b.meta.menu.name) return -1;
            if (a.meta.menu.name > b.meta.menu.name) return 1;
            return 0;
          });
          route.submenus = sorted;
        }
      }

      return routes;
    }
  },
  data() {
    return {};
  },
  mounted() {
    var nav = document.getElementById("side-nav");
    if (nav)
      document.documentElement.style.setProperty(
        "--side-nav-width",
        `${nav.clientWidth}px`
      );
  }
};
</script>

<style lang="scss" scoped>
#side-nav li.menu-parent {
  &:hover {
    .sidebar-submenu {
      display: block;
    }
  }
  a.router-link-active + .sidebar-submenu {
    display: block;
  }
  .sidebar-submenu {
    display: none;
  }
  .sidebar-submenu {
    margin: 0;
    padding: 0;
    > li {
      display: flex;
      flex-direction: column;
    }
    > li a {
      background-color: darken(#1e282c, 3);
      &.router-link-active {
        background-color: darken(#1e282c, 4);
      }
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
